import {
  EAgentClientAccountingPeriod,
  EAgentClientDocumentType,
  EAgentClientSigningBasis,
  ELeadClientStatus,
} from 'src/containers/LeadCompanyClients';
import {EResellerIds} from 'src/containers/User';

export default {
  title: 'Agents',
  addAgent: ' agent',
  searchPlaceholder: 'Quick search by agent',
  createLink: 'Create link',
  status: {
    [ELeadClientStatus.WAITING]: 'Pending activation',
    [ELeadClientStatus.REQUIRES_ATTENTION]: 'Pending activation',
    [ELeadClientStatus.ACCEPTED]: 'Active',
    [ELeadClientStatus.ERROR]: 'Blocked',
    [ELeadClientStatus.CANCELLED]: 'Expired',
  },
  th: {
    createdAt: 'Registration date',
    company: 'Company name',
    status: 'Agent status',
  },
  filters: {
    status: 'Agent status',
    period: 'Select period',
    clients: 'Agents',
  },
  createForm: {
    another: 'Other',
    title: 'Company details and contact',
    commonInfo: 'General details',
    companyName: 'Company name',
    agentName: 'Internal Agent Name',
    taxNumber: 'TIN',
    kzTaxNumber: 'TIN',
    resellerId: 'Jurisdiction',
    documentInfo: 'Contract details',
    signingBasisNumber: 'Number',
    signingBasisDate: 'Date',
    certificateHint:
      'Enter the series and number for the certificate of sole proprietorship registration, for example 11 №123456789',
    taxRate: 'Select tax rate',
    customTaxRate: 'Tax rate, %',
    signatoryInfo: 'Agent’s authorized signatory',
    signingBasis: 'Signing authority basis',
    selectSigningBasis: 'Select authority basis',
    signatoryLastName: 'Signatory last name',
    signatoryFirstName: 'Signatory first name',
    signatoryMiddleName: 'Signatory middle name (if any)',
    contactsInfo: 'Contacts',
    contactName: 'Contact details',
    email: 'Email',
    phone: 'Phone number',
    responsibleManagerId: 'Assigned edna manager',
    createButton: 'Create Agent ',
  },
  signingBasis: {
    [EAgentClientSigningBasis.CHARTER]: 'Charter',
    [EAgentClientSigningBasis.ENTRUSTMENT]: 'Power of attorney',
    [EAgentClientSigningBasis.ORDER]: 'Order',
    [EAgentClientSigningBasis.CERTIFICATE]: 'Certificate of sole proprietorship registration',
  },
  taxRateNoVat: {
    [EResellerIds.OSK_ID]: 'VAT exemption under Article 145.1 of the Russian Tax Code',
    [EResellerIds.KZ_ID]: 'VAT exempt',
    [EResellerIds.MFM_ID]: 'VAT exempt',
  },
  agentInfo: {
    status: 'Agent status:',
    companyInfo: 'Company details',
    taxNumber: 'TIN',
    kzTaxNumber: 'TIN',
    taxRate: 'Tax rate',
    editInfo: 'Edit details',
    documentInfo: 'Contract details',
    contractHint: 'The full terms are described in your agreement with edna',
    documentType: 'Contract type',
    documentNumber: 'Contract number',
    documentDate: 'Date of contract',
    accountingPeriod: 'Reporting period',
    commissionPercentage: 'Agent commission rate',
    contactsInfo: 'Contacts',
    responsibleManager: 'Assigned edna manager',
    signingInfo: '{{basis}} {{info}}',
    signingDetails: '{{number}} from {{date}}',
  },
  accountingPeriod: {
    [EAgentClientAccountingPeriod.MONTH]: 'Calendar month',
    [EAgentClientAccountingPeriod.QUARTER]: 'Calendar quarter',
  },
  documentType: {
    [EAgentClientDocumentType.AGENT_AGREEMENT]: 'Offer',
    [EAgentClientDocumentType.AGENT_CONTRACT]: 'Agreement',
  },
  supportAction: {
    seeAsClient: "See client's cabinet",
    payments: 'Client payments',
    clients: 'Client list',
  },
  editModal: {
    title: 'Edit company details',
    submitButton: 'Save changes',
  },
  errors: {
    uniqueAgentName: 'An agent with this name already exists',
    uniqueTaxNumber: 'An agent with this TIN already exists',
    uniqueTaxNumberKz: 'An agent with this TIN already exists',
    uniqueEmail: 'A profile with this email already exists',
    invalidTaxRate: 'The value cannot be equal to {{value}}',
  },
  firstLoginModal: {
    title: 'Check the information for reporting documents',
    description:
      'These documents will be the basis for agent commission payments. Please confirm or edit the data to generate the statement report.',
  },
  supportButton: {
    payments: 'Client payments',
    clients: 'Client list',
  },
};
